/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Chat_Workedfor1Inputs */

const zh_chat_workedfor1 = /** @type {(inputs: Chat_Workedfor1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用时 ${i?.duration}`)
};

const en_chat_workedfor1 = /** @type {(inputs: Chat_Workedfor1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Worked for ${i?.duration}`)
};

const es_chat_workedfor1 = /** @type {(inputs: Chat_Workedfor1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trabajó durante ${i?.duration}`)
};

/**
* | output |
* | --- |
* | "Worked for {duration}" |
*
* @param {Chat_Workedfor1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const chat_workedfor1 = /** @type {((inputs: Chat_Workedfor1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Workedfor1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_chat_workedfor1(inputs)
	if (locale === "en") return en_chat_workedfor1(inputs)
	return es_chat_workedfor1(inputs)
});
export { chat_workedfor1 as "chat_workedFor" }